import {
  IMarketplaceLocationRequestFilter, IMarketplaceRangeRequestFilter,
  IMarketplaceRequestFilter, IMarketplaceStaticLinkParams,
} from 'src/components/profileComponents/Marketplace/types';
import { UrlConfigure } from 'src/typings/app';

const linksPropsMapping = {
  typePlacementUrl: UrlConfigure.typePlacementUrl,
};

const getMappedProp = (prop: string): string => {
  // @ts-ignore
  return linksPropsMapping[prop] ? linksPropsMapping[prop] : prop;
};

export const getLinkParams = (dynamicParams: IMarketplaceRequestFilter[], staticParams?: IMarketplaceStaticLinkParams[], propertyName: 'oldSystemName' | 'propertyName' = 'oldSystemName'): string => {
  if (!dynamicParams?.length) {
    return '';
  }
  const arr = [
    ...staticParams?.map((item) => ({
      oldSystemName: item.param,
      equals: item.value,
    })) || [],
    ...dynamicParams,
  ];
  let result = '';
  arr.forEach((link, index) => {
    // @ts-ignore
    const sign = ((!index && link[propertyName]) || result === '') ? '?' : '&';
    // @ts-ignore
    if ('equals' in (link as IMarketplaceLocationRequestFilter) && (link as IMarketplaceLocationRequestFilter)[propertyName]) {
      // @ts-ignore
      result += `${sign}${getMappedProp((link as IMarketplaceLocationRequestFilter)[propertyName])}=${(link as IMarketplaceLocationRequestFilter).equals}`;
    }
    // @ts-ignore
    if (('min' && 'max') in link && (link as IMarketplaceRangeRequestFilter)[propertyName]) {
      // @ts-ignore
      result += `${sign}${getMappedProp((link as IMarketplaceRangeRequestFilter)[propertyName])}=${(link as IMarketplaceRangeRequestFilter).min};${(link as IMarketplaceRangeRequestFilter).max}`;
    }
  });
  return result;
};

export const toggleLinkParams = <T, >(arrayState: T[], arrayItem: T) => {
  if (arrayState.includes(arrayItem)) {
    const index = arrayState.indexOf(arrayItem);
    arrayState.splice(index, 1);
  } else {
    arrayState.push(arrayItem);
  }
  return arrayState;
};
